// src/components/Header.js
import { NavLink } from "react-router-dom";
import { useState } from "react";
import "./Header.css";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="navbar">
      <div className="logo">
        <NavLink to="/" className="logo-link">
          Welcome Inn
        </NavLink>
      </div>

      <nav className={`nav-links ${isOpen ? "open" : ""}`}>
        <NavLink
          to="/rooms"
          className="nav-link"
          activeClassName="active"
          onClick={() => setIsOpen(false)}
        >
          Rooms
        </NavLink>
        <NavLink
          to="/amenities"
          className="nav-link"
          activeClassName="active"
          onClick={() => setIsOpen(false)}
        >
          Amenities
        </NavLink>
        <NavLink
          to="/nearby"
          className="nav-link"
          activeClassName="active"
          onClick={() => setIsOpen(false)}
        >
          What’s Nearby
        </NavLink>
        <NavLink
          to="/booking"
          className="nav-link"
          activeClassName="active"
          onClick={() => setIsOpen(false)}
        >
          Book Your Stay
        </NavLink>
      </nav>

      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>
    </header>
  );
}

export default Header;
